import Cookies from "./Cookie";

export default Cookies;